import SimpleLoader from "Components/Shared/SimpleLoader";
import { useAsset } from "Hooks/Endpoints";
import React from "react";
import AssetCreateForm from "./AssetCreateForm";
import AssetEditForm from "./AssetEditForm";
import AssetList from "./AssetList";

const AssetView = () => {
  const { asset, createAsset, loading } = useAsset();
  return (
    <SimpleLoader loading={loading}>
      {!asset && !createAsset && <AssetList />}
      {!asset && createAsset && <AssetCreateForm />}
      {asset && <AssetEditForm />}
    </SimpleLoader>
  );
};

export default AssetView;
